import React, { memo, useEffect, useState, useRef } from 'react';
import { Card } from 'tea-component';
import { SortBy } from "tea-component/table/addons";
import Filter, {
  IFilter,
} from '@gp/pages/StudioDashboard/StudioOverall/Tabs/People/Details/components/Filter';
import Headcounts from '../Headcounts';
import HeadcountCost from '../HeadcountCost';
import { useRequest, useMemoizedFn } from 'ahooks';
import {
  fetchStudioOverallPeopleTimeRange,
  // fetchStudioOverallPeopleChartData,
  fetchStudioOverallPeopleHeadcountsData,
  fetchStudioOverallPeopleHeadcountCostData,
} from '@gp/pages/StudioDashboard/StudioOverall/services/studioOverall';
import { formatMonth } from '@gp/pages/StudioDashboard/StudioOverall/Tabs/People/utils/common';
import './index.scss';

interface OverviewPropsType {
  className?: string;
  style?: React.CSSProperties;
  filterBOLoading: boolean;
  selectBO: string[];
  // setFiveYearLoading: React.Dispatch<React.SetStateAction<boolean>> | null;
  // setFiveYearResList: React.Dispatch<React.SetStateAction<any>> | null;
  // setFiveYearUpdateTime: React.Dispatch<React.SetStateAction<string>> | null;
}

const DEFAULT_PROPS: OverviewPropsType = {
  className: '',
  style: {},
  filterBOLoading: true,
  selectBO: [],
  // setFiveYearLoading: null,
  // setFiveYearResList: null,
  // setFiveYearUpdateTime: null,
};

function Overview(props: OverviewPropsType) {
  const {
    className,
    style,
    filterBOLoading,
    selectBO,
    // setFiveYearLoading,
    // setFiveYearResList,
    // setFiveYearUpdateTime,
  } = props;

  const [filter, setFilter] = useState<IFilter>({
    date_type: 'Month',
    start_date: '',
    end_date: '',
  });
  // 用于请求接口时，控制是否改变5Y Headcounts模块的数据
  // const [isThrowFiveYearList, setIsThrowFiveYearList] = useState<boolean>(true);
  const headcountsSortParamsRef = useRef<SortBy>({
    by: '',
    order: undefined,
  });
  const headcountCostSortParamsRef = useRef<SortBy>({
    by: '',
    order: undefined,
  });

  // 时间筛选器接口，返回的日期范围是有数据的
  const { data: timeRangeData, loading: timeRangeLoading } = useRequest(
    fetchStudioOverallPeopleTimeRange,
  );

  /* const {
    data: chartData,
    loading: chartLoading,
    run: chartRun,
  } = useRequest(fetchStudioOverallPeopleChartData, {
    manual: true,
    onFinally(params, data, e) {
      if (isThrowFiveYearList) {
        setFiveYearResList?.(data?.headcounts_y5 || null);
        setFiveYearUpdateTime?.(data?.update_time_y5 || '');
        setIsThrowFiveYearList(false);
        setFiveYearLoading?.(false);
      }
    },
  }); */

  const {
    data: headcountsData,
    loading: headcountsLoading,
    run: headcountsRun,
  } = useRequest(fetchStudioOverallPeopleHeadcountsData, {
    manual: true,
  });
  const {
    data: headcountCostData,
    loading: headcountCostLoading,
    run: headcountCostRun,
  } = useRequest(fetchStudioOverallPeopleHeadcountCostData, {
    manual: true,
  });

  const handleFilterChange = useMemoizedFn((payload: IFilter) => {
    const newFilter = { ...filter, ...payload };
    setFilter(newFilter);
    // 影响Headcounts、Headcount Cost两块内容
    /* chartRun({
      start_date: payload?.start_date || '',
      end_date: payload?.end_date || '',
      management_team: selectBO,
      metrics: ['headcount', 'headcount_cost'], // headcount, headcount_cost
    }); */
    headcountsRun({
      start_date: payload?.start_date || '',
      end_date: payload?.end_date || '',
      management_team: selectBO,
      order_metric: formatMonth(headcountsSortParamsRef?.current?.by),
      order: headcountsSortParamsRef?.current?.order,
    });
    headcountCostRun({
      start_date: payload?.start_date || '',
      end_date: payload?.end_date || '',
      management_team: selectBO,
      order_metric: formatMonth(headcountCostSortParamsRef?.current?.by),
      order: headcountCostSortParamsRef?.current?.order,
    });
  });

  // BO筛选器变化及初始化默认日期，默认选当前年份所有月份，当前年份没有数据时，取最近年份所有月份
  // 影响Headcounts、Headcount Cost、5Y Headcounts三块内容
  useEffect(() => {
    // setFiveYearLoading?.(filterBOLoading || timeRangeLoading);
    if (
      filterBOLoading ||
      timeRangeLoading ||
      !timeRangeData?.start_date ||
      !timeRangeData?.end_date
    ) {
      return;
    }
    const initEndDate = timeRangeData?.end_date || '';
    const initStartDate =
      Number(initEndDate?.substring(0, 4)) >
      Number(timeRangeData?.start_date?.substring(0, 4))
        ? `${initEndDate?.substring(0, 4)}-01-01`
        : timeRangeData?.start_date || '';
    // 初始化时
    if (!filter?.start_date && !filter?.end_date) {
      setFilter({
        date_type: 'Month',
        start_date: initStartDate,
        end_date: initEndDate,
      });
      /* chartRun({
        start_date: initStartDate,
        end_date: initEndDate,
        management_team: selectBO,
        metrics: ['headcount', 'headcount_cost', '5y_headcounts'], // headcount, headcount_cost, 5y_headcounts
      }); */
      const params = {
        start_date: initStartDate,
        end_date: initEndDate,
        management_team: selectBO,
        order_metric: '',
        order: '',
      };
      headcountsRun(params);
      headcountCostRun(params);
      // 不是初始化，仅BO筛选器变化时
    } else {
      /* chartRun({
        start_date: filter?.start_date,
        end_date: filter?.end_date,
        management_team: selectBO,
        metrics: ['headcount', 'headcount_cost', '5y_headcounts'], // headcount, headcount_cost, 5y_headcounts
      }); */
      const params = {
        start_date: filter?.start_date,
        end_date: filter?.end_date,
        management_team: selectBO,
        order_metric: formatMonth(headcountsSortParamsRef?.current?.by),
        order: headcountsSortParamsRef?.current?.order,
      };
      headcountsRun(params);
      params.order_metric = formatMonth(headcountCostSortParamsRef?.current?.by);
      params.order = headcountCostSortParamsRef?.current?.order;
      headcountCostRun(params);
    }
    // setIsThrowFiveYearList(true);
    // setFiveYearLoading?.(true);
  }, [
    timeRangeData?.start_date,
    timeRangeData?.end_date,
    filterBOLoading,
    selectBO,
  ]);

  return (
    <Card
      className={`dbg-studio-overall-people-overview dbg-trigger-view-card ${className}`}
      style={style}
    >
      <Card.Body title="Overview">
        <Filter
          dateRangeData={
            timeRangeLoading
              ? undefined
              : {
                  start_date: timeRangeData?.start_date || '',
                  end_date: timeRangeData?.end_date || '',
                }
          }
          loading={timeRangeLoading}
          filter={filter}
          isLimitMaxSelectRange
          onFilterChange={handleFilterChange}
        />
        <Headcounts
          loading={filterBOLoading || timeRangeLoading || headcountsLoading}
          data={headcountsData?.headcounts || null}
          filterStartDate={filter?.start_date}
          filterEndDate={filter?.end_date}
          selectBO={selectBO}
          sortParamsRef={headcountsSortParamsRef}
          headcountsRun={headcountsRun}
        />
        <HeadcountCost
          loading={filterBOLoading || timeRangeLoading || headcountCostLoading}
          data={headcountCostData?.headcounts_cost || null}
          filterStartDate={filter?.start_date}
          filterEndDate={filter?.end_date}
          selectBO={selectBO}
          sortParamsRef={headcountCostSortParamsRef}
          headcountCostRun={headcountCostRun}
        />
      </Card.Body>
    </Card>
  );
}

Overview.defaultProps = DEFAULT_PROPS;

export default memo(Overview);
